import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/sections";

// thumbnails of the files picked in the form
const NewPreviews = ({ files }) => {
  const [urls, setUrls] = useState([]);
  useEffect(() => {
    const list = files && files.length ? Array.from(files).map((f) => URL.createObjectURL(f)) : [];
    setUrls(list);
    return () => list.forEach((u) => URL.revokeObjectURL(u));
  }, [files]);
  if (!urls.length) return null;
  return (
    <div className="d-flex flex-wrap mt-2" style={{ gap: 8 }}>
      {urls.map((u) => (
        <img key={u} src={u} alt="Preview" width="90" height="90" style={{ objectFit: "cover", borderRadius: 6 }} />
      ))}
    </div>
  );
};

const EditInfo = ({ id, handleClose }) => {
  const { getData, IMG_URL } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [existing, setExisting] = useState([]); // [{ id, image }]
  const [removeIds, setRemoveIds] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      const response = await withLoader(() => getData(`${API_URL}/${id}`));
      const d = { ...(response?.data || {}) };
      setExisting(d.images || []);
      delete d.images;
      reset(d);
    })();
    // eslint-disable-next-line
  }, [id]);

  const toggleRemove = (imageId) =>
    setRemoveIds((prev) => (prev.includes(imageId) ? prev.filter((x) => x !== imageId) : [...prev, imageId]));

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("title", data.title);
      sendData.append("description", data.description);
      sendData.append("cta_text", data.cta_text || "");
      sendData.append("cta_link", data.cta_link || "");
      sendData.append("sort_order", data.sort_order || 0);
      sendData.append("remove_image_ids", JSON.stringify(removeIds));
      if (data.images && typeof data.images !== "string" && data.images.length) {
        Array.from(data.images).forEach((file) => sendData.append("images", file));
      }

      const response = await withLoader(() => putData(`${API_URL}/${id}`, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit About Us Information <small className="text-muted">(ID {id})</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={9}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="e.g. Shopping experience"
                        maxLength={160}
                        className={classNames("w-100", { "is-invalid": errors?.title })}
                        {...register("title", {
                          required: "Name is required",
                          maxLength: { value: 160, message: "Maximum 160 characters" },
                        })}
                      />
                    </InputGroup>
                    {errors.title && <span className="text-danger">{errors.title.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={3}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Information</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="Information"
                        className={classNames("w-100", { "is-invalid": errors?.description })}
                        {...register("description", { required: "Information is required" })}
                      />
                    </InputGroup>
                    {errors.description && <span className="text-danger">{errors.description.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Button Text (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={80}
                        placeholder="e.g. Try out our virtual try-on"
                        className="w-100"
                        {...register("cta_text")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Button Link (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={255}
                        placeholder="e.g. /quick-quiz"
                        className="w-100"
                        {...register("cta_link")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              {existing.length > 0 && (
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Form.Label>Current Images</Form.Label>
                    <div className="d-flex flex-wrap" style={{ gap: 12 }}>
                      {existing.map((im) => {
                        const removed = removeIds.includes(im.id);
                        return (
                          <div key={im.id} style={{ textAlign: "center", opacity: removed ? 0.35 : 1 }}>
                            <img
                              src={IMG_URL + im.image}
                              alt=""
                              width="90"
                              height="90"
                              style={{ objectFit: "cover", borderRadius: 6, display: "block" }}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger mt-1"
                              onClick={() => toggleRemove(im.id)}
                            >
                              {removed ? "Undo" : "Remove"}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                    <small className="text-muted">Removed images are deleted when you press Save.</small>
                  </div>
                </Col>
              )}

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Add More Images</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="file" accept="image/*" multiple className="w-100" {...register("images")} />
                    </InputGroup>
                    <NewPreviews files={watch("images")} />
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default EditInfo;